import * as React from 'react';
import { Button } from '@rtkwlf/ui';
import Icon from '../../../widgets/Icons';
import LightTooltip, {
  TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE,
} from '../../../widgets/LightTooltip';
import { VirtualLogCollector } from '../../../types';
import styled from 'styled-components';

export type Props = {
  vlc: VirtualLogCollector;
  onRegister: (vlc: VirtualLogCollector) => void;
  onDecommission: (vlc: VirtualLogCollector) => void;
};

const ActivationButton = styled(Button)`
  :disabled {
    color: #666;
    background: #ddd;
    border-color: #888;
  }
`;

export const ColumnAction: React.FunctionComponent<Props> = ({
  vlc,
  onRegister,
  onDecommission,
}) => {
  const activate = () => onRegister(vlc);
  const decommission = () => onDecommission(vlc);

  return (
    <div className="d-flex">
      <LightTooltip
        block
        tooltip={
          vlc?.product_type?.toLowerCase() === 'vsensor'
            ? 'Activate virtual sensor'
            : vlc?.product_type?.toLowerCase() === 'vlc'
            ? 'Activate virtual log collector'
            : vlc?.is_vanilla
            ? 'Activate physical appliance'
            : 'Activate virtual appliance'
        }
        delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
        placement={'bottom'}
        size={'lg'}
      >
        <ActivationButton
          className="px-2 mr-2"
          onClick={activate}
          disabled={vlc.state === 'registered'}
          data-cy="activate"
        >
          <Icon.Power />
        </ActivationButton>
      </LightTooltip>

      <LightTooltip
        block
        tooltip={
          vlc?.product_type?.toLowerCase() === 'vsensor'
            ? 'Decommission virtual sensor'
            : vlc?.product_type?.toLowerCase() === 'vlc'
            ? 'Decommission virtual log collector'
            : vlc?.is_vanilla
            ? 'Decommission physical appliance'
            : 'Decommission virtual appliance'
        }
        delay={TOOLTIP_DELAY_WAIT_SHOW_INSTANT_HIDE}
        placement={'bottom'}
        size={'lg'}
      >
        <Button
          className="px-2"
          type="danger"
          onClick={decommission}
          disabled={false}
          data-cy="decommission"
          ghost
        >
          <Icon.Trash />
        </Button>
      </LightTooltip>
    </div>
  );
};
